import { BaseApi } from '@shared/config';
import type { GetCitiesRequest, GetCitiesResponse } from './types';

class CityApi extends BaseApi {
  getCities = (params: GetCitiesRequest): Promise<GetCitiesResponse> => {
    return this.instance.get('/cities', { params });
  };
}

export const cityApi = new CityApi();
/** @deprecated Используйте cityApi */
export const regionApi = cityApi;
